import { ComponentStyleConfig, extendTheme } from '@chakra-ui/react'

const ButtonStyle: ComponentStyleConfig = {
  // style object for base or default style
  baseStyle: {
    pt: '0.5em',
    pb: '0.5em'
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {},
  // styles for different visual variants ("outline", "solid")
  variants: {
    solid: {
      bg: 'brand.300',
      color: 'brand.100',
      p: '0.5em',
      _hover: {
        bg: 'brand.500',
      },
      _focus: {
        bg: 'brand.500',
      }
    },
    solidSecondary: {
      bg: 'brand.700',
      color: 'brand.500',
      p: '0.5em',
      _disabled: {
        bg: 'brand.200',
        color: 'brand.100',
        opacity: 0.5
      }
    }
  },
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {
    size: '',
    variant: 'solid',
    colorScheme: 'brand',
  },
}

const LinkStyle: ComponentStyleConfig = {
  defaultProps: {
    variant: 'brand'
  },
  variants: {
    brand: {
      color: 'brand.500'
    },
    white: {
      color: 'brand.100'
    }
  }
}

const ProgressStyle: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'brand2',
    borderRadius: '1em'
  },
}

export const theme = extendTheme({
  colors: {
    brand: {
      100: '#FFFFFF',
      200: '#787878',
      300: '#007196',
      500: '#33344C',
      600: '#E6E7E8',
      700: '#ECDB14',
      800: '#D50000',
    },
    brand2: {
      500: '#ECDB14',
    }
  },
  components: {
    Button: ButtonStyle,
    Link: LinkStyle,
    Progress: ProgressStyle,
  }
});